
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AvisoSinGuardar extends Vue {
	@Prop({ default: false }) private value!: boolean;
}
